import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import { registrationTheme } from '#app/theme';
import { HardRedirect } from './Redirect';
import BrokerSharing from './pages/BrokerSharing/BrokerSharing';
import { LicenseInfo } from '@mui/x-license';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import NotFound from './pages/NotFound/NotFound';

// Set the license key for the x-grid
// This is public so it's fine to commit according to the MUI docs
// https://mui.com/x/introduction/licensing/#where-to-install-the-key
LicenseInfo.setLicenseKey(
  'f8f556d1e66eace7eb667567c93ed6d3Tz04Nzc2MSxFPTE3NDM3ODc3NzcwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI='
);

export const App: React.FC = () => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <ThemeProvider theme={registrationTheme}>
        <BrowserRouter>
          <Routes>
            <Route
              path="/registration/account-details"
              element={<HardRedirect />}
            />

            <Route
              path="/registration/start-application"
              element={<HardRedirect />}
            />

            <Route
              path="/registration/wait-for-email"
              element={<HardRedirect />}
            />

            <Route
              path="/registration/broker-sharing/d41d8cd98f00b204e9800998ecf8427e"
              element={<BrokerSharing />}
            />

            <Route path="/registration/404" element={<NotFound />} />

            <Route path="/registration" element={<HardRedirect />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </LocalizationProvider>
  );
};

export default App;
